import React from 'react';
import { pricing } from '../data/content';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
export function Offer() {
  return <section id="oferta" className="scroll-mt-16 bg-paper py-20 sm:py-24" aria-labelledby="offer-title" data-id="element-125" data-mp="17wjn6a9wp4yk">
      <div className="mx-auto max-w-[880px] px-5 sm:px-8" data-id="element-126" data-mp="1mpd4m18qnv5v">
        <h2 id="offer-title" className="text-center font-display text-[2.1rem] leading-tight text-petrol sm:text-5xl" data-id="element-127" data-mp="1hpqrrswtogxl">
          Tu inversión hoy
        </h2>
        <div className="mt-10 rounded-[2rem] bg-cream p-7 text-center shadow-soft ring-1 ring-cream-line sm:p-12" data-id="element-128" data-mp="p00cvhnd9b0f">
          <p className="text-sm font-semibold uppercase tracking-[0.16em] text-petrol" data-id="element-129" data-mp="13xawxfe2rp7r">
            Megapack Maestro de Sesiones — Sistema completo
          </p>
          <p className="mt-6 text-ink-mute" data-id="element-130" data-mp="z0aq329eiifl">Valor total: {pricing.totalValue}</p>
          <p className="mt-2 font-display text-6xl leading-none text-petrol sm:text-7xl" data-id="element-131" data-mp="2fad4jky754fs">
            <span className="mr-2 align-middle text-2xl text-terra sm:text-3xl" data-id="element-132" data-mp="2actocfhxuhl7">Hoy</span>
            {pricing.today}
          </p>
          <p className="mx-auto mt-5 w-fit rounded-md bg-sage-wash px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-sage-deep" data-id="element-133" data-mp="ujboqb8lmgz9">
            Pago único · Acceso de por vida
          </p>
          <p className="mx-auto mt-6 max-w-lg leading-relaxed text-ink-soft" data-id="element-134" data-mp="13k000y6ly38g">
            6 módulos profesionales · +300 páginas · 5 bonos profesionales · Acceso inmediato · Acceso de por vida
          </p>
          <div className="mt-8" data-id="element-135" data-mp="bskhpgc332o1">
            <CtaButton checkout block className="!px-4 !text-[13px] sm:!text-[15px]" data-id="element-136" data-mp="btlupqcntz8e">
              Quiero acceder a Maestro de Sesiones
            </CtaButton>
          </div>
        </div>
        <div className="mt-6" data-id="element-137" data-mp="km5xn2zzipz1">
          <TrustRow data-id="element-138" data-mp="kmfcbufkxapf" />
        </div>
      </div>
    </section>;
}